import infoComponentInit from "./info_component_init"

export default {
  infoComponentInit: infoComponentInit,
}
